module.exports = __webpack_public_path__ + "img/MSBCCNBJXXX.593f4163.png";